import { AuthLayout } from "../components/ui/auth-layout"
import { VerifyAccount } from "../components/auth/verify-account"

export default function VerifyAccountPage() {
  return (
    <AuthLayout
      title="Account Activation"
      subtitle="Verified your email and activated your account"
      showBackButton={false}
    >
      <VerifyAccount />
    </AuthLayout>
  )
}
